// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBSk-5ccO7VhWTfWNFUyZRkkE3Dax9LCNc",
  authDomain: "shopping-app-5cbfc.firebaseapp.com",
  projectId: "shopping-app-5cbfc",
  storageBucket: "shopping-app-5cbfc.appspot.com",
  messagingSenderId: "810212853373",
  appId: "1:810212853373:web:4788e4eae1d3fae1ec9314"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;